import { formatToPTBRNumber } from 'commons/utils/number'
import { Tooltip } from 'components'

import * as S from './styles'

interface OverviewValueProps {
  icon: React.ReactNode
  title: string
  subtitle: string
  tooltip: string
  value: number
  iconColorBackground?: string
  visible?: boolean
}

export const OverviewValue = ({
  icon,
  title,
  subtitle,
  tooltip,
  value,
  iconColorBackground = 'none',
  visible = true,
}: OverviewValueProps) => {
  if (!visible) return null

  return (
    <S.ValueRow>
      <S.IconContainer background={iconColorBackground}>{icon}</S.IconContainer>

      <S.ValueTexts>
        <S.TitleRow>
          <S.Title>{title}</S.Title>
          <Tooltip arrow placement="top" title={tooltip}>
            <S.TooltipIcon />
          </Tooltip>
        </S.TitleRow>

        <S.ValueWrapper>
          <S.Value>{subtitle}</S.Value>
          <S.Value>{formatToPTBRNumber(value)}</S.Value>
        </S.ValueWrapper>
      </S.ValueTexts>
    </S.ValueRow>
  )
}
